<button #button [appSkin]="skin" [ngClass]="{ 'disabled': isDisabled, 'gray': isGrayBtn }" [type]="type">
	<app-icon [ngStyle]="{'font-size': size + 'px' }">{{icon}}</app-icon>
	<span>
		<ng-content></ng-content>
	</span>
</button>
